// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as Spread$Showside from "../utils/Spread.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ListPageGridCustomSlots$Showside from "./ListPageGridCustomSlots.bs.js";
function ListPageGrid(Props) {
  var columns = Props.columns;
  var children = Props.children;
  var gapOpt = Props.gap;
  var maxRowsOpt = Props.maxRows;
  var maxWidth = Props.maxWidth;
  var paddingOverride = Props.paddingOverride;
  var verticalPaddingOpt = Props.verticalPadding;
  var firstChild = Props.firstChild;
  var lastChild = Props.lastChild;
  var alwaysShowLastChildOpt = Props.alwaysShowLastChild;
  var className = Props.className;
  var gap = gapOpt !== undefined ? gapOpt : /* Equal */0;
  var maxRows = maxRowsOpt !== undefined ? maxRowsOpt : 0;
  var verticalPadding = verticalPaddingOpt !== undefined ? verticalPaddingOpt : false;
  var alwaysShowLastChild = alwaysShowLastChildOpt !== undefined ? alwaysShowLastChildOpt : false;
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var columnNum = Card$Showside.Size.getColumns(columns);
  var childrenNum = children.length + (Belt_Option.isNone(firstChild) ? 0 : 1) | 0;
  var insertSlots = ListPageGridCustomSlots$Showside.use(columnNum, undefined);
  var maxItems = maxRows > 0 ? Math.max(Math.imul(maxRows, columnNum), 1) : 0;
  var maxItems$1 = maxItems > 0 ? maxItems - (isMobile || Belt_Option.isNone(lastChild) || maxItems === childrenNum ? 0 : 1) | 0 : maxItems;
  var lastChild$1 = childrenNum > maxItems$1 && maxItems$1 > 0 || alwaysShowLastChild ? lastChild : undefined;
  var gridPadding = match.windowSize.width <= 600 ? "px-4" : "px-8";
  var gridPadding$1 = Belt_Option.isNone(paddingOverride) ? gridPadding : "";
  var gapCn;
  if (typeof gap === "number") {
    switch (gap) {
      case /* Equal */0:
        gapCn = "gap-col-custom";
        break;
      case /* Half */1:
        gapCn = "gap-col-custom-half";
        break;
      case /* Double */2:
        gapCn = "gap-col-custom-double";
        break;
    }
  } else {
    gapCn = "";
  }
  var gapCn$1;
  var tmp = match$1.route;
  gapCn$1 = typeof tmp === "number" || tmp.TAG !== /* ListPage */1 ? gapCn : columns !== 3 ? columns >= 8 && !isMobile ? "gap-1" : gapCn : isMobile ? "gap-1" : gapCn;
  var gapInt = typeof gap === "number" ? undefined : CSS$Showside.intToPx(gap._0);
  var tmp$1 = {
    gridAutoColumns: "minmax(0, 1fr)"
  };
  var tmp$2 = Belt_Option.map(maxWidth, CSS$Showside.intToPx);
  if (tmp$2 !== undefined) {
    tmp$1.maxWidth = tmp$2;
  }
  var tmp$3 = Belt_Option.map(paddingOverride, CSS$Showside.intToPx);
  if (tmp$3 !== undefined) {
    tmp$1.paddingRight = tmp$3;
  }
  var tmp$4 = Belt_Option.map(paddingOverride, CSS$Showside.intToPx);
  if (tmp$4 !== undefined) {
    tmp$1.paddingLeft = tmp$4;
  }
  if (gapInt !== undefined) {
    tmp$1.gridGap = gapInt;
  }
  var style = tmp$1;
  var tmp$5;
  switch (columns) {
    case /* OneColumnGrid */0:
      tmp$5 = "grid-cols-1";
      break;
    case /* TwoColumnGrid */1:
      tmp$5 = "grid-cols-2";
      break;
    case /* ThreeColumnGrid */2:
      tmp$5 = "grid-cols-3";
      break;
    case /* FourColumnGrid */3:
      tmp$5 = "grid-cols-4";
      break;
    case /* FiveColumnGrid */4:
      tmp$5 = "grid-cols-5";
      break;
    case /* SixColumnGrid */5:
      tmp$5 = "grid-cols-6";
      break;
    case /* SevenColumnGrid */6:
      tmp$5 = "grid-cols-7";
      break;
    case /* EightColumnGrid */7:
      tmp$5 = "grid-cols-8";
      break;
    case /* TwelveColumnGrid */8:
      tmp$5 = "grid-cols-12";
      break;
  }
  var className$1 = Cn.make([CSS$Showside.prefix(gridPadding$1), CSS$Showside.prefix("grid"), CSS$Showside.prefix("mx-auto"), CSS$Showside.prefix("w-full"), CSS$Showside.prefix(gapCn$1), CSS$Showside.prefix(tmp$5), Belt_Option.getWithDefault(className, "")]);
  var childrenWithFirstChild = React.useMemo(function () {
    return Belt_Array.concat(firstChild !== undefined ? [Caml_option.valFromOption(firstChild)] : [], children);
  }, [children, firstChild]);
  var childrenWithTruncation = React.useMemo(function () {
    return Belt_Array.keepWithIndex(childrenWithFirstChild, function (child, i) {
      if (maxItems$1 < 1) {
        return true;
      } else {
        return i < maxItems$1;
      }
    });
  }, [childrenWithFirstChild, maxItems$1]);
  var childrenWithSlots = React.useMemo(function () {
    return Curry._1(insertSlots, childrenWithTruncation);
  }, [childrenWithTruncation, columnNum, insertSlots]);
  var childrenWithLastChild = React.useMemo(function () {
    return Belt_Array.concat(childrenWithSlots, lastChild$1 !== undefined ? [Caml_option.valFromOption(lastChild$1)] : []);
  }, [childrenWithSlots, lastChild$1]);
  var renderLastChild = function (param) {
    if (lastChild$1 !== undefined) {
      return React.createElement(Spread$Showside.make, {
        props: {
          isListItem: true
        },
        children: Caml_option.valFromOption(lastChild$1)
      });
    } else {
      return null;
    }
  };
  var isSymmetric = columnNum === 1 || childrenWithSlots.length / columnNum % 1.0 === 0.0;
  if (lastChild$1 !== undefined && isSymmetric) {
    var tmp$6 = {};
    if (gapInt !== undefined) {
      tmp$6.gridGap = gapInt;
    }
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "list-page-grid",
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["grid grid-cols-1", gapCn$1])),
        style: tmp$6
      }, React.createElement("div", {
        className: className$1,
        style: style
      }, childrenWithSlots), React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make([gridPadding$1, "m-auto", "w-full"])),
        style: style
      }, renderLastChild(undefined)))
    });
  } else {
    return React.createElement(DataAttribute$Showside.make, {
      dataTestId: "list-page-grid",
      children: React.createElement("div", {
        className: Cn.make([className$1, verticalPadding ? "py-row-custom" : ""]),
        style: style
      }, childrenWithLastChild)
    });
  }
}
ListPageGrid.displayName = "ListPageGrid";
var make = ListPageGrid;
export { make };
/* react Not a pure module */